export default "__VITE_ASSET__47512c24__"